import React from "react"
import HeroView from "../components/index/HeroView"
import LastCaseStudy from "../components/index/LastCaseStudy"
import Contact from "../components/index/Contact"
import AboutUs from "../components/index/AboutUs"
import Offer from "../components/index/Offer"
import Team from "../components/index/Team"
import Reasons from "../components/index/Reasons"
import LastProjects from "../components/index/LastProjects"
import SEO from "../components/layout/seo"
import Layout from "../components/layout/layout"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "animate.css/animate.min.css"

const IndexPage = () => {
  return (
    <Layout>
      <SEO
        title="Nis Media - Agencja interaktywna kreująca lokalne marki | Strony internetowe, E-commerce, Marketing"
        description="W Nis Media budujemy wizerunek lokalnych marek - tworzymy zepół który najlepiej zadba o reklamę twojej firmy"
        canonical="/"
      />
      <HeroView />
      <AboutUs />
      <Offer />
      <Team />
      <Reasons />
      <LastProjects />
      <LastCaseStudy />
      <Contact />
    </Layout>
  )
}

export default IndexPage
